import React, { useState,useEffect } from "react";
import Header from '../layout/header';
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import MapComponent from "./MapComponent";
import axios from 'axios'
import CorporateImage from '../../Images/new_corporate.png'
import ApartmentImage from '../../Images/new_apartment.png'
import UsedCarImage from '../../Images/ucd_logo.png'
import MallImage from '../../Images/new_mall.png'
import Seller from '../../Images/seller.png'
import callWebService, {callTypes} from "../../service/Networks/network";
import Config from "../../service/Config/config";

function getCurrentPosition() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    });
}

const fetchLocations = async (latitude, longitude, token, setErrorMessage) => {
    try {
        const base_url = process.env.REACT_APP_API_URL;
        const response = await callWebService(callTypes.get,'',`${Config?.heatMap}?latitude=${latitude}&longitude=${longitude}`);

        if (response.status !== 200) {
            throw new Error('Failed to fetch data');
        }
        console.log(response)
        const responseData = response.data;

        if (responseData && responseData.response && responseData.response.data) {
            return responseData.response.data.map(location => ({
                lat: parseFloat(location.latitude),
                lng: parseFloat(location.longitude),
                client_name: location.client_name,
                project_type: location.project_type,
                live_date:location.live_date,
                newRate:location.newRate,
            }));
        }
        if (responseData && responseData.message) {
            throw new Error(responseData.message);
        }
        return [];
    } catch (error) {
        console.error('Failed to fetch locations:', error);
        setErrorMessage(error.message);
        return [];
    }
};

const Heatmap = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [locations, setLocations] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [selectedProjectType, setSelectedProjectType] = useState('All');
    const [siteCounts, setSiteCounts] = useState({ corporate: 0, society: 0, mall: 0,NCD:0 });
    const [apiMessage, setApiMessage] = useState('');

    const token = localStorage.getItem('token');

    useEffect(() => {
        const loadLocations = async () => {
            setIsLoading(true);
            try {
                const position = await getCurrentPosition();
                setLatitude(position.coords.latitude);
                setLongitude(position.coords.longitude);

                const locationsData = await fetchLocations(position.coords.latitude, position.coords.longitude, token,setApiMessage);
                setLocations(locationsData);
                updateFilteredLocations(locationsData, selectedProjectType);

            } catch (error) {
                setApiMessage(error.message);
                console.error('Error fetching geolocation:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadLocations();
    }, [token]);

    useEffect(() => {
        let webView = localStorage.getItem('webview');

        if (typeof window !== "undefined" && typeof window.Moengage?.track_event === "function") {
            window.Moengage.track_event("page_loaded", {
               
                category: "leadx",
                event: "page_loaded",
                page_name: "Leadx - Heatmap",
                platform: "LEADX",
                primary_source: "parkplus_leadx_webview",
                referer_source: "organic"
              });
        }

        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'screenshot_prevent',
                page_name: 'yes',
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                setTimeout(function () {
                    nativeObject.postMessage(JSON.stringify(message));
                    window.addEventListener('message', () => {
                    })
                  }, 100);
            }
        }
    }, []);

    const updateFilteredLocations = (locations, projectType) => {
        const counts = { Corporate: 0, Society: 0, Mall: 0,NCD:0, UCD: 0 };
        const filtered = locations.filter(location => {
            if (projectType === 'All' || location.project_type === projectType) {
                if (location.project_type === 'Corporate') counts.Corporate++;
                if (location.project_type === 'Society') counts.Society++;
                if (location.project_type === 'Mall') counts.Mall++;
                if (location.project_type === 'ncd') counts.NCD++;
                if (location.project_type === 'ucd') counts.UCD++;
                return true;
            }
            return false;
        });
        setFilteredLocations(filtered);
        setSiteCounts(counts);
    };

    const handleProjectTypeChange = (event) => {
        const selectedType = event.target.value;
        setSelectedProjectType(selectedType);
        updateFilteredLocations(locations, selectedType);
    };

    const icons = {
        Corporate: CorporateImage,
        Society: ApartmentImage,
        Mall: MallImage,
        NCD:Seller,
        UCD: UsedCarImage
    };
    
    return (
      <>
        <Loader isLoading={isLoading} />

        <div id="wrapper">
          <DashboardMenu />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header title={'Park+ Heat Map'} />
              <div className="container-fluid common-bg">
                {apiMessage =='' ? (
                <div className="container-fluid bootstrap snippets bg-white">
                    <div className="row d-flex" style={{justifyContent: "center"}}>
                        <h1 className="h3 mb-4 mt-4 text-black-100"><b>Park+ HeatMap</b></h1>
                    </div>
                    <div className="row d-flex mb-3" style={{justifyContent: "center"}}>
                      <div className="col-md-12 col-sm-6">
                        <select onChange={handleProjectTypeChange} value={selectedProjectType} className="form-control">
                          <option value="All">All</option>
                          <option value="Corporate">Corporate</option>
                          <option value="Society">Apartment</option>
                          <option value="Mall">Mall</option>
                          <option value="ncd">NCD</option>
                          <option value="ucd">UCD</option>
                        </select>
                      </div>
                    </div>
                   <div className="row d-flex justify-content-between mb-4" style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px'}}>
                        {Object.keys(siteCounts).map(key => (
                            <div
                                key={key}
                                className="summary-item d-flex align-items-center"
                                style={{
                                    maxWidth: '80%',
                                    padding: '10px',
                                    margin: 'auto',
                                    textAlign: window.innerWidth < 768 ? 'left' : 'center'
                                }}
                            >
                                <img
                                    src={icons[key]}
                                    alt={key}
                                    style={{
                                        width: key === 'UCD' ? 55 : 30,
                                        height: key === 'UCD' ? 55 : 30,
                                        marginRight: 10
                                    }}
                                />
                                <div>
                                    <h5 style={{ margin: 0 }}>{key}</h5>
                                    <p style={{ margin: 0 }}>{siteCounts[key]} sites</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="card">
                        <MapComponent locations={filteredLocations} latitude={latitude} longitude={longitude} /> 
                    </div>
                </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '20px',
                        color: '#fff', 
                        border: '1px solid #000', 
                        backgroundColor: '#473381', 
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        marginTop: '100px',
                        width: '60%', 
                        height: '200px', 
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }}>
                        <h2 style={{ margin: '0 0 10px 0' }}>Info Message</h2>
                        <p>{apiMessage}</p>
                    </div>
                )} 
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  
export default Heatmap;